
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/dodaj-pelny-sim",
      function () {
        return require("private-next-pages/moje-konto/dodaj-pelny-sim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/dodaj-pelny-sim"])
      });
    }
  